import React, { FC, ReactNode } from 'react';
import { StyledResidenceParam } from './styled';
import { FlexCenterAligned } from '../../../styled/common';

interface ResidenceParamProps {
  param: string;
  icon: ReactNode;
  hideOnMobile?: boolean;
}

export const ResidenceParam: FC<ResidenceParamProps> = ({
  param,
  icon,
  hideOnMobile
}) => (
  <StyledResidenceParam $hideOnMobile={hideOnMobile}>
    <FlexCenterAligned>{icon}</FlexCenterAligned>
    <span>{param}</span>
  </StyledResidenceParam>
);
